import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { UppChartComponent, UppChartData, UppChartLegendPosition, UppChartOptions, UppChartType, uppChartPalette } from '@unpispas/upp-wdgt';

const REPORT_PAYMENT_COLORS: Record<string, string> = {
    PAYCASH: 'rgba(47, 223, 117, 0.8)',
    PAYCARD: 'rgba(255, 213, 52, 0.8)',
    PAYLINE: 'rgba(66, 140, 255, 0.8)',
    PAYACCOUNT: 'rgba(112, 68, 255, 0.8)'
};

const DEMO_REPORT_CHART_OPTIONS: UppChartOptions = {
    maintainAspectRatio: false,
    plugins: {
        legend: {
            display: true,
            position: 'bottom',
            align: 'end'
        }
    },
    scales: {
        x: {},
        y: {
            beginAtZero: true
        }
    }
};

@Component({
    selector: 'demo-upp-chart',
    templateUrl: './demo-upp-chart.html',
    styleUrls: ['../demo-common.scss', './demo-upp-chart.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DemoUppChartComponent {
    @ViewChild(UppChartComponent) chart?: UppChartComponent;

    type: UppChartType = 'bar';
    height = '280px';
    legendPosition: UppChartLegendPosition = 'bottom';
    legendMaxLines = 4;
    legendOtherLabel = 'Other';
    legendShowValue = false;
    legendValueDecimals: number | null = null;
    legendValueSuffix = '';
    options: UppChartOptions<UppChartType> = {
        ...DEMO_REPORT_CHART_OPTIONS,
        plugins: {
            ...DEMO_REPORT_CHART_OPTIONS.plugins,
            legend: {
                ...(DEMO_REPORT_CHART_OPTIONS.plugins?.legend || {}),
                display: false
            }
        }
    };

    data: UppChartData<UppChartType> = {
        labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
        datasets: [
            {
                label: 'Sales',
                data: [120, 180, 160, 220, 260, 210, 190],
                backgroundColor: uppChartPalette(7, 0.55),
                borderColor: 'rgba(56, 128, 255, 1)',
                borderWidth: 2
            }
        ]
    };

    constructor(private change: ChangeDetectorRef) {
        // nothing to do
    }

    setType(type: UppChartType): void {
        this.type = type;
        this.legendShowValue = false;
        this.legendValueDecimals = null;
        this.legendValueSuffix = '';
        this.change.markForCheck();
    }

    setLegendPosition(position: UppChartLegendPosition): void {
        this.legendPosition = position;
        this.change.markForCheck();
    }

    showPaymentDoughnut(): void {
        const paymentKeys = ['PAYCASH', 'PAYCARD', 'PAYLINE', 'PAYACCOUNT'];
        this.type = 'doughnut';
        this.options = {
            ...DEMO_REPORT_CHART_OPTIONS,
            scales: {
                x: { display: false },
                y: { display: false }
            }
        } as UppChartOptions<UppChartType>;
        this.data = {
            labels: paymentKeys,
            datasets: [
                {
                    data: [420, 250, 150, 180],
                    borderAlign: 'inner',
                    borderColor: 'rgb(0, 0, 0)',
                    backgroundColor: paymentKeys.map((key) => REPORT_PAYMENT_COLORS[key] || 'rgba(255, 73, 97, 0.8)')
                }
            ]
        };
        this.legendMaxLines = 3;
        this.legendShowValue = true;
        this.legendValueDecimals = 2;
        this.legendValueSuffix = '€';
        this.change.markForCheck();
    }

    randomizeData(): void {
        const values = Array.from({ length: 7 }, () => Math.round(Math.random() * 300));
        this.data = {
            ...this.data,
            datasets: [
                {
                    ...this.data.datasets[0],
                    data: values
                }
            ]
        };
        this.change.markForCheck();
    }

    exportPng(): void {
        this.chart?.downloadImage('upp-chart-demo', 'image/png');
    }

    exportJpg(): void {
        this.chart?.downloadImage('upp-chart-demo', 'image/jpeg');
    }
}
